var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mavon-editor',{staticClass:"md",attrs:{"value":_vm.value,"subfield":false,"defaultOpen":'preview',"toolbarsFlag":false,"editable":false,"scrollStyle":true,"boxShadow":false,"transition":false,"previewBackground":"#ffffff"}})
}
var staticRenderFns = []

export { render, staticRenderFns }